import * as React from 'react';
import {
	FormCheckConditional,
	ToggleSwitch
} from '../../../../../components/forms';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
	gender?: string;
}
const MedicalQuestion3: React.StatelessComponent<Props> = props => {
	const { questions, questionnaire, onQuestionnaireBlur, onQuestionnaireChange, gender } = props;
	const isNextDisabled = () => {
		if (questionnaire.furtherExamination == null
			|| (questionnaire.furtherExamination && gender === 'female' && questionnaire.furtherExaminationPregnancy == null)
		) {
			return true;
		}

		return questionnaire.notConsultedDoctor == null;
	};

	return (
		<div>
			<ToggleSwitch
				labelText={questions.furtherExamination}
				name="furtherExamination"
				onChildren="Yes"
				offChildren="No"
				onBlur={onQuestionnaireBlur}
				onChange={onQuestionnaireChange}
				checked={questionnaire.furtherExamination}
				className="toggle-yes-no"
				conditionalChildren={(
					<FormCheckConditional isOpen={gender === 'female' && questionnaire.furtherExamination}>
						<ToggleSwitch
							labelText={questions.furtherExaminationPregnancy}
							name="furtherExaminationPregnancy"
							onChildren="Yes"
							offChildren="No"
							onBlur={onQuestionnaireBlur}
							onChange={onQuestionnaireChange}
							checked={questionnaire.furtherExaminationPregnancy}
							className="mb-2 toggle-yes-no"
						/>
					</FormCheckConditional>
				)}
			/>
			<ToggleSwitch
				labelText={questions.notConsultedDoctor}
				name="notConsultedDoctor"
				onChildren="Yes"
				offChildren="No"
				onBlur={onQuestionnaireBlur}
				onChange={onQuestionnaireChange}
				checked={questionnaire.notConsultedDoctor}
				className="toggle-yes-no"
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default MedicalQuestion3;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion3/MedicalQuestion3.tsx